import { render, staticRenderFns } from "./ResumoAnalise.vue?vue&type=template&id=ff516b56&"
import script from "./ResumoAnalise.vue?vue&type=script&lang=js&"
export * from "./ResumoAnalise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports